export const MIN_DATE = new Date(-8640000000000000);
